/* Uses the same calendar-week rule as the mattress promotion, including DST. */
(() => {
  if (customElements.get('weekly-offer-countdown')) return;

  const zonedParts = (date, formatter) => Object.fromEntries(
    formatter.formatToParts(date).filter(({ type }) => type !== 'literal').map(({ type, value }) => [type, Number(value)])
  );
  const wallTime = (parts) => Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
  const nextMonday = (now, formatter) => {
    const parts = zonedParts(now, formatter);
    const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
    const days = (8 - date.getUTCDay()) % 7 || 7;
    const target = date.getTime() + days * 86400000;
    let instant = target;
    for (let i = 0; i < 4; i += 1) {
      const correction = target - wallTime(zonedParts(new Date(instant), formatter));
      instant += correction;
      if (!correction) break;
    }
    return instant;
  };

  class WeeklyOfferCountdown extends HTMLElement {
    connectedCallback() {
      if (this.interval) return;
      const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' };
      try {
        this.dateFormatter = new Intl.DateTimeFormat('en-GB', { ...options, timeZone: this.dataset.timezone || 'Europe/Paris' });
      } catch (_) {
        this.dateFormatter = new Intl.DateTimeFormat('en-GB', { ...options, timeZone: 'Europe/Paris' });
      }
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      this.interval = null;
    }

    tick(now = new Date()) {
      const time = this.querySelector('[data-weekly-offer-time]');
      if (!time) return;
      if (!this.deadline || now.getTime() >= this.deadline || now.getTime() < this.lastTick) {
        this.deadline = nextMonday(now, this.dateFormatter);
      }
      this.lastTick = now.getTime();
      const seconds = Math.max(0, Math.floor((this.deadline - now.getTime()) / 1000));
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor(seconds % 86400 / 3600);
      const minutes = Math.floor(seconds % 3600 / 60);
      const value = `${days}${this.dataset.day} ${hours}${this.dataset.hour} ${minutes}${this.dataset.minute}`;
      if (time.textContent !== value) time.textContent = value;
      this.hidden = false;
    }
  }

  customElements.define('weekly-offer-countdown', WeeklyOfferCountdown);
})();
